require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./calculators-how-do-taxes-and-inflation-affect-my-savings.json") })
        }
      }, "path---calculators-how-do-taxes-and-inflation-affect-my-savings");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---calculators-how-do-taxes-and-inflation-affect-my-savings!./.cache/json/calculators-how-do-taxes-and-inflation-affect-my-savings.json
// module id = 1999
// module chunks = 231608221292675